/* src/app/views/collection/components/edit-collection/edit-collection-header/edit-collection-header.component.scss */
/*# sourceMappingURL=edit-collection-header.component.css.map */
